import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Homepage from './Components/Homepage';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from "react-router-dom";
import Booking from './Components/Booking';
import Navbar from './Components/ui/Navbar';
import Social from './Components/Social';
import About from './Components/About';
import Events, { AdminEventManager } from './Components/Events';
import AdminLogin from './Components/AdminLogin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/Events" element={<Events />} />
        <Route path="/events" element={<Events />} />
        <Route path="/Booking" element={<Booking />} />
        <Route path="/Social" element={<Social />} />
        <Route path="/About" element={<About />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/events" element={<AdminEventManager />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
